// libs
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

// types
import { BreadCrumbs } from 'shared/types/breadCrumbs';

// constants
import { DEFAULT_CURRENCY_CODE } from 'shared/constants';
import { CANONICAL_HOMEPAGE_URL as DOMAIN_NAME } from 'shared/constants/pages';

export const getReviewData = (review: Review.IReviewSummary) => {
  const data = {};
  if (isEmpty(review) || !review?.show_ratings || review.review_count < 1) {
    return data;
  }

  const topReview = get(review, 'top_reviews.0', {});
  if (isEmpty(topReview) === false) {
    data.review = {
      '@type': 'Review',
      reviewRating: {
        '@type': 'Rating',
        ratingValue: topReview.rating,
        bestRating: '5',
      },
      author: {
        '@type': 'Person',
        name: topReview.nickname,
      },
    };
  }
  if (review.star_rating && review.star_rating_count) {
    data.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: review.star_rating,
      ratingCount: review.star_rating_count,
      reviewCount: review.review_count,
    };
  }

  return data;
};

export const getBreadCrumbsData = (breadCrumbs: BreadCrumbs) => {
  if (!breadCrumbs.length) return;

  const data = { breadCrumbs: {} };

  const breadCrumbList = breadCrumbs.map((crumb, index) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: crumb?.key,
      item: `${DOMAIN_NAME}${crumb?.value}`,
    };
  });

  data.breadCrumbs = {
    '@type': 'BreadcrumbList',
    itemListElement: breadCrumbList,
  };

  return data;
};

export const getJSONLD = ({
  metaInfo,
  title,
  subTitle,
  SKU,
  isOutOfStock,
  price,
  hasDiscount,
  discountPrice,
  review,
  breadCrumbs,
}: {
  metaInfo: ProductDetail.IMetaData;
  title: string;
  subTitle: string;
  SKU: string;
  isOutOfStock: boolean;
  price: number;
  hasDiscount: boolean;
  discountPrice: number;
  review: Review.IReviewSummary;
  breadCrumbs: BreadCrumbs;
}) => {
  const brand = title ? { '@type': 'Brand', name: title } : undefined;

  return JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: `${title} ${subTitle}`,
    description: metaInfo.description,
    image: metaInfo.imgUrl,
    sku: SKU,
    mpn: SKU,
    brand,
    offers: {
      '@type': 'Offer',
      url: metaInfo.productUrl,
      priceCurrency: DEFAULT_CURRENCY_CODE,
      price: hasDiscount ? discountPrice : price,
      itemCondition: 'https://schema.org/NewCondition',
      availability: `https://schema.org/${isOutOfStock ? 'OutOfStock' : 'InStock'}`,
    },
    ...getReviewData(review),
    ...getBreadCrumbsData(breadCrumbs),
  });
};
